import { isVideoUrl, mediaExtension } from './mediaType'

// A tiny media fragment lets Safari decode the opening frame without playback.
export default function videoPreviewUrl(url) {
  if (!url || url.includes('#')) return url

  // Safari cannot start some older imports when a time fragment follows their upload suffix.
  if (isVideoUrl(url) && !url.split(/[?#]/)[0].toLowerCase().endsWith(`.${mediaExtension(url)}`)) return url

  return `${url}#t=0.001`
}

// Persisted posters use the same owner-scoped key as the original video.
export function videoPosterUrl(url, record) {
  if (record && Array.isArray(record.related_posters) && Array.isArray(record.related_files)) {
    const index = record.related_files.indexOf(url)
    if (record.related_posters[index]) return record.related_posters[index]
  }
  if (!url || url.includes('?')) return undefined

  return `${url.split('#')[0]}.poster.jpg`
}
